import React from "react";
import fields from "../../json/GuestFeilds.json";
import FormInput from "Common/Custom/FormInput";
import FormInputFile from "Common/Custom/FormInputFile";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormSelect from "Common/Custom/FormSelect";
import FormPhoneInput from "Common/Custom/FormPhoneInput";

const EditGuestForm = ({
  values,
  errors,
  handleChange,
  handleFileChange,
  handleSubmit,
  loading,
  title = "Update Guest",
  id_proof_frontPreview,
  id_proof_backPreview,
}) => {
  
  const { formdata } = fields;

  return (
    <PageBody onSubmit={handleSubmit} headerchildren={<HeadingOne>{title}</HeadingOne>}>
      {formdata.map((field) => {

        if (field.type === "file") {
          return (
            <FormInputFile
              key={field.name}
              field={field}
              handleChange={handleFileChange}
              error={errors[field.name]}
              imagePreview={field.name === "id_proof_front" ? id_proof_frontPreview : id_proof_backPreview}
            />
          );
        }

        if (field.type === "select") {
          return (
            <FormSelect
              key={field.name}
              field={field}
              value={values[field.name]}
              handleChange={handleChange}
              options={field.options}
              error={errors[field.name]}
            />
          );
        }

        if (field.type === "tel") {
          return (
            <FormPhoneInput
              key={field.name}
              field={field}
              value={values[field.name]}
              country_code={values["country_dial_code"]}
              handleChange={handleChange}
              error={errors[field.name]}
            />
          );
        }

        // default text/number input
        return (
          <FormInput
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );

      })}

      <FormSubmitButton
        label="Update"
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

export default EditGuestForm;